// src/components/ui/LoadingSpinner.jsx
import React from 'react';

const LoadingSpinner = ({ message }) => (
  <div className="spinner-container">
    <div className="spinner-ring">
      <div></div><div></div><div></div><div></div>
    </div>
    {message && <p className="spinner-message">{message}</p>}
  </div>
);

export default LoadingSpinner;
